import React from "react";
import moment from "moment";
import { useNavigate, useParams } from "react-router";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import useMutation from "src/hooks/useMutation";
import { CREATE_SHIPMENT_MUTATION } from "src/constants/graphql/mutations";
import { serverFormatSeconds } from "src/utils/dates";
import Progress from "../../../wizard/Progress";
import Header from "../../../wizard/Header";
import useAuth from "../../../../hooks/useAuth";
import ActionsButton from "./ActionsButton";

export default function Details({ project, onClose }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { settings } = user.company;
  const [createShipment, { loading }] = useMutation(CREATE_SHIPMENT_MUTATION);
  const { projectId } = useParams();

  const nextStep = ({ shipmentStatus }) => {
    const isDraftType = shipmentStatus === "draft" || shipmentStatus === "onsite_inventory";

    createShipment({
      variables: {
        input: {
          projectId: parseInt(projectId),
          startTime: isDraftType ? null : moment(new Date()).format(serverFormatSeconds),
          draft: shipmentStatus === "draft",
          shipmentStatus,
        },
      },
    }).then(({ data }) => {
      const pathname = window.location.pathname;
      const params = new URLSearchParams(window.location.search);
      params.set("step", "shipment");
      params.set("shipmentId", data.createShipment.shipment.shipmentId);
      params.set("id", data.createShipment.shipment.id);
      navigate({ pathname, search: params.toString() });
    });
  };

  return (
    <>
      <Header title={`Key ${settings.filter_field2} Details`} />
      <Box
        p={2}
        minHeight={400}
        display="flex"
        flexGrow={1}
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box>
          <Grid container spacing={1}>
            <Grid size={12}>
              <TextField
                size="small"
                fullWidth
                disabled
                value={project.name}
                label={`${settings.filter_field2} Name`}
              />
            </Grid>
            <Grid size={12}>
              <TextField
                size="small"
                multiline
                fullWidth
                disabled
                value={project.customerNotes}
                label={`${settings.filter_field2} Notes`}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Progress step={0} />
      <Box px={2} py={1.5} display="flex" justifyContent="flex-end" alignItems="center">
        <ActionsButton loading={loading} onClick={nextStep} project={project} />
      </Box>
    </>
  );
}
